import "./PreguntasTalles.css";

export const PreguntasTallesBombers = () => {
  const bombers = [
    {
      icon: "A",
      name: "Ancho de hombro",
      S: "10 cm",
      M: "11 cm",
      L: "12 cm",
    },
    {
      icon: "B",
      name: "Contorno de pecho",
      S: "112 cm",
      M: "122 cm",
      L: "132 cm",
    },
    {
      icon: "C",
      name: "Contorno de cintura",
      S: "115 cm",
      M: "125 cm",
      L: "135 cm",
    },
    {
      icon: "D",
      name: "Contorno de cadera",
      S: "115 cm",
      M: "125 cm",
      L: "135 cm",
    },
    {
      icon: "E",
      name: "Largo de manga",
      S: "63 cm",
      M: "68 cm",
      L: "73 cm",
    },
    {
      icon: "F",
      name: "Largo de talle",
      S: "63 cm",
      M: "68 cm",
      L: "73 cm",
    },
  ];

  return (
    <table className="preguntas-item-content-talles">
      <thead>
        <tr>
          <th>Tabla de talles</th>
          <th>Talle S</th>
          <th>Talle M</th>
          <th>Talle L</th>
        </tr>
      </thead>
      <tbody>
        {bombers.map((file, index) => (
          <tr key={index}>
            <th>
              <div>
                <span>{file.icon}</span>
              </div>
              {file.name}
            </th>
            <td>{file.S}</td>
            <td>{file.M}</td>
            <td>{file.L}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};
